import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSolidMessageCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M0 16c0 8.8 7.2 16 16 16s16-7.2 16-16S24.8 0 16 0 0 7.2 0 16Zm12.25 5.375c1.035 0 1.875.84 1.875 1.875v.625l2.832-2.125a1.881 1.881 0 0 1 1.125-.375H23.5a.627.627 0 0 0 .625-.625V9.5a.627.627 0 0 0-.625-.625h-15a.627.627 0 0 0-.625.625v11.25c0 .344.281.625.625.625h3.75Zm1.875 4.844-.008.008-.199.148-.668.5a.632.632 0 0 1-.656.059.622.622 0 0 1-.344-.559V23.25H8.5a2.502 2.502 0 0 1-2.5-2.5V9.5C6 8.121 7.121 7 8.5 7h15C24.879 7 26 8.121 26 9.5v11.25c0 1.379-1.121 2.5-2.5 2.5h-5.418l-3.957 2.969Zm-1.616-10.21a1.25 1.25 0 1 1-1.768-1.768 1.25 1.25 0 0 1 1.768 1.768Zm4.375-1.768a1.25 1.25 0 1 1-1.768 1.768 1.25 1.25 0 0 1 1.768-1.768Zm4.375 1.768a1.25 1.25 0 1 1-1.768-1.768 1.25 1.25 0 0 1 1.768 1.768Z",
		clipRule: "evenodd"
	})
});
export default SvgSolidMessageCircle;
